import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {addMessageBoxInfo} from '../../common/messageBox/actions/actions';

export const fetchAllTechnicians = () => {
  return apiActionCreator({
    'endpoint': '/accessories/technicians?type=all',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_TECHNICIAN,
      ActionTypes.FETCHED_TECHNICIAN,
      [
        ActionTypes.FETCHED_TECHNICIAN_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const addNewTechnician = (data) => {
  return apiActionCreator({
    'endpoint': '/accessories/technicians',
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_TECHNICIAN,
      ActionTypes.ADDED_TECHNICIAN,
      [
        ActionTypes.ADDED_TECHNICIAN_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });
};

export const updateTechnician = (data) => {
  return apiActionCreator({
    'endpoint': '/accessories/technicians',
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_TECHNICIAN,
      [
        ActionTypes.UPDATED_TECHNICIAN,
        addMessageBoxInfo('El tecnico se ha actualizado exitosamente.'),
      ],
      [
        ActionTypes.UPDATED_TECHNICIAN_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });
};

export const clearTechnicians = () => ({
  'type': ActionTypes.CLEAR_TECHNICIANS,
});
